import * as React from "react";
const IconClose = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M17 7 7 17M7 7l10 10"
      stroke="currentcolor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconClose;
